<template>
  <div class="home">
    <!-- 标语 -->
    <!-- <div
      class="slogan container"
      v-if="webPositionData[0]"
      @click="detailHandle(webPositionData[0]['infoData'][0]['strId'])"
    >
      <div v-if="webPositionData[0]['infoData'].length > 0">
        <h2>{{ webPositionData[0]["infoData"][0]["strMasTitle"] }}</h2>
      </div>
      <div v-else class="no-content">暂无数据</div>
    </div> -->
    <div
      class="bannerfont"
      @click="linkHandleout()"
      v-if="linkout && linkout.length"
      v-html="titleVal"
    ></div>
    <div
      class="bannerfont"
      @click="detailHandle(titleValid)"
      v-else
      v-html="titleVal"
    ></div>
    <div class="top container" :class="{ flex: !isSpecial }">
      <!-- Swiper -->
      <Swiper
        v-if="webPositionData[1]"
        :isSpecial="isSpecial"
        :swiperArr="webPositionData[1]['infoData']"
      ></Swiper>
      <!-- 右侧图片 -->
      <div class="row topnews" v-if="false">
        <div class="title">
          <span>{{ webPositionData[2].strName }}</span>
          <i @click="navHandle(webPositionData[2]['strId'])">
            更多>>
            <img src="../assets/images/arrow-r.png" alt="" />
          </i>
        </div>
        <ul v-if="webPositionData[2]['infoData'].length > 0">
          <li
            v-for="(item, index) in webPositionData[2]['infoData']"
            :key="index"
          >
            <div @click="detailNews(item)">
              {{ item.strMasTitle }}
            </div>
          </li>
        </ul>
        <div v-else class="no-content">暂无数据</div>
      </div>
    </div>
    <div class="top container" :class="{ flex: !isSpecial }">
      <!-- Swiper -->
      <div class="row mainnews left" v-if="webPositionData[2] && !isSpecial">
        <div class="title">
          <div class="beforetitle"></div>
          <span>{{ webPositionData[2].strName }}</span>
          <i>_________</i>
          <div @click="navHandle(webPositionData[2]['strId'])">
            更多>>
            <img src="../assets/images/arrow-r.png" alt="" />
          </div>
          <!-- <div class="titleline"></div> -->
        </div>
        <ul v-if="webPositionData[2]['infoData'].length > 0">
          <li
            v-for="(item, index) in webPositionData[2]['infoData']"
            :key="index"
          >
            <div @click="detailNews(item)">
              {{ item.strMasTitle }}
            </div>
          </li>
        </ul>
        <div v-else class="no-content">暂无数据</div>
      </div>
      <!-- 右侧图片 -->
      <div class="row mainnews" v-if="webPositionData[3] && !isSpecial">
        <div class="title">
          <div class="beforetitle"></div>
          <span>{{ webPositionData[3].strName }}</span>
          <i>_________</i>
          <!-- <img src="../assets/images/line.png" alt /> -->
          <div @click="navHandle(webPositionData[3]['strId'])">
            更多>>
            <img src="../assets/images/arrow-r.png" alt="" />
          </div>
          <!-- <div class="titleline"></div> -->
        </div>
        <ul v-if="webPositionData[3]['infoData'].length > 0">
          <li
            v-for="(item, index) in webPositionData[3]['infoData']"
            :key="index"
          >
            <div @click="detailNews(item)">
              {{ item.strMasTitle }}
            </div>
            <!-- <span>{{ item.strPubDate }}</span> -->
          </li>
        </ul>
        <div v-else class="no-content">暂无数据</div>
      </div>
    </div>
    <div class="top container" :class="{ flex: !isSpecial }">
      <!-- 代表风采 -->
      <div class="row mainnews left" v-if="webPositionData[4] && !isSpecial">
        <div class="title">
          <div class="beforetitle"></div>
          <span>{{ webPositionData[4].strName }}</span>
          <i>_________</i>
          <div @click="navHandle(webPositionData[4]['strId'])">
            更多>>
            <img src="../assets/images/arrow-r.png" alt="" />
          </div>
          <!-- <div class="titleline"></div> -->
        </div>
        <ul v-if="webPositionData[4]['infoData'].length > 0">
          <li
            v-for="(item, index) in webPositionData[4]['infoData']"
            :key="index"
          >
            <div @click="detailNews(item)">
              {{ item.strMasTitle }}
            </div>
          </li>
        </ul>
        <div v-else class="no-content">暂无数据</div>
      </div>
      <!-- 政协活动 -->
      <div class="row mainnews" v-if="webPositionData[5] && !isSpecial">
        <div class="title">
          <div class="beforetitle"></div>
          <span>{{ webPositionData[5].strName }}</span>
          <i>_________</i>
          <!-- <img src="../assets/images/line.png" alt /> -->
          <div @click="navHandle(webPositionData[5]['strId'])">
            更多>>
            <img src="../assets/images/arrow-r.png" alt="" />
          </div>
          <!-- <div class="titleline"></div> -->
        </div>
        <ul v-if="webPositionData[5]['infoData'].length > 0">
          <li
            v-for="(item, index) in webPositionData[5]['infoData']"
            :key="index"
          >
            <div @click="detailNews(item)">
              {{ item.strMasTitle }}
            </div>
            <!-- <span>{{ item.strPubDate }}</span> -->
          </li>
        </ul>
        <div v-else class="no-content">暂无数据</div>
      </div>
    </div>
    <!-- 友情链接 -->
    <!-- <div class="link"></div>
    <div class="links container" style="padding-left: 15px">
      <div class="tit">
        <img src="../assets/images/link.png" />
      </div>
      <ul class="flex flex-y-center" v-if="navigationForZxArr.length > 0">
        <li v-for="(item, index) in navigationForZxArr" :key="index">
          <img @click="linkHandle(item)" :src="item.strPicPath" alt />
        </li>
      </ul>
      <div v-else class="no-content">暂无数据</div>
    </div> -->
  </div>
</template>

<script>
import Swiper from "@/components/base/swiper.vue";

import "swiper/css/swiper.min.css";
import { homeData, bodyData, navigationForZx } from "@/api/configuration";
import { get } from "../utils/helpers";

export default {
  name: "Home",
  components: {
    Swiper,
  },
  data() {
    return {
      photoWidth: "", // 精彩图片宽度
      calleft: 0, // 精彩图片左移尺寸
      webPositionData: [], // 中间内容列表
      navigationForZxArr: [], // 友情链接数据
      isSpecial: false,
      titleVal: "",
      linkout: "",
    };
  },
  props: {},
  computed: {},
  created() {
    this.isSpecial =
      this.$route.query.strWebSiteId === "b4a5ad6f2ad74fe6a2310d313bba36b7" ||
      this.$route.query.strWebSiteId === "4b4dc894e2894d4c966c03db2669de03";
    this.getInfoData(); // 获取首页数据
    this.getNavigationForZx(); // 获取友情链接数据
  },
  mounted() {},
  methods: {
    //获取首页数据
    getInfoData() {
      const that = this;
      homeData({
        strWebSiteId:
          this.$store.state.strWebSiteId || "0ce5ec1a0ae0463f8e4de81ae39616c2",
      })
        .then((res) => {
          let firstData = res.data.data;
          document.title = firstData.strName;
          const data = firstData.webPositionData;

          data.forEach(async (v, k) => {
            let curObj = data[k];
            await bodyData({
              strColId: curObj.strColId,
              strColName: curObj.strColName,
              intCount: curObj.intCount,
            })
              .then((res) => {
                const secData = res.data.data;
                that.$set(that.webPositionData, k, secData);
                if (k === 0 && secData.infoData && secData.infoData.length) {
                  this.titleVal = secData.infoData[0].strMasTitle;
                  this.linkout = secData.infoData[0].strUrl;
                  this.titleValid = secData.infoData[0].strId;
                }

                if (k === 5 && secData.infoData && secData.infoData.length) {
                  that.photoWidth = 290 * Number(secData.infoData.length) * 2;
                  that.move();
                }
              })
              .catch((err) => {
                that.$message.destroy();
                that.$message.error(err);
              });
          });
        })
        .catch((err) => {
          this.$message.destroy();
          this.$message.error(err);
        });
    },

    //获取友情链接数据
    getNavigationForZx() {
      navigationForZx({ strWebSiteId: this.$store.state.strWebSiteId })
        .then((res) => {
          this.navigationForZxArr = get(["data", "linksPic"], res.data);
        })
        .catch((err) => {
          this.$message.destroy();
          this.$message.error(err);
        });
    },

    //移动
    move() {
      this.timer = setInterval(this.starmove, 20);
    },

    //开始移动
    starmove() {
      this.calleft -= 0.6;
      let lengthVal = this.webPositionData[5]["infoData"].length;
      if (this.calleft <= -(290 * Number(lengthVal))) {
        this.calleft = 0;
      }
    },

    //鼠标悬停时停止移动
    stopmove() {
      clearInterval(this.timer);
    },

    // 更多菜单跳转
    navHandle(strId) {
      let routeData = this.$router.resolve({
        path: "/list",
        query: { strWebSiteId: this.$route.query.strWebSiteId, strId: strId },
      });
      window.open(routeData.href, "_blank");
    },

    // 跳转详情
    detailHandle(strId) {
      let routeData = this.$router.resolve({
        path: "/detail",
        query: { strWebSiteId: this.$route.query.strWebSiteId, strId: strId },
      });
      window.open(routeData.href, "_blank");
    },
    // 要闻跳转
    detailNews(item) {
      if (item.strUrl) {
        this.linkHandle(item);
      } else {
        this.detailHandle(item.strId);
      }
    },

    // 友情链接
    linkHandle(item) {
      window.open(item.strUrl, "_blank"); //跳转至新页面
    },
    // 友情链接
    linkHandleout() {
      window.open(this.linkout, "_blank"); //跳转至新页面
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.home {
  background-size: 100% 100%;
  min-width: 1250px;
  padding: 0px 0 40px;
  .bannerfont {
    text-align: center;
    color: #ce0801;
    font-size: 36px;
    letter-spacing: -1px;
    font-family: SourceHanSansCN-Heavy;
    font-weight: 700;
    margin-bottom: 34px;
    margin-top: 34px;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .container {
    width: 1200px;
    margin: 0 auto;
  }
  .no-content {
    box-sizing: border-box;
    font-size: 18px;
    text-align: center;
    min-height: 200px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .slogan {
    box-sizing: border-box;
    padding: 50px 15px 30px;
    h2 {
      font-size: 36px;
      font-weight: bold;
      color: #ce0801;
      line-height: 45px;
      text-align: center;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    p {
      font-size: 18px;
      color: #333333;
      line-height: 28px;
    }
    i {
      display: inline-block;
      font-style: normal;
      color: #bb2c1b;
      cursor: pointer;
    }
  }
  .top {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
    .tit {
      color: #e40000;
      font-size: 30px;
      font-weight: bold;
      border-left: 8px solid #e40000;
      padding-left: 17px;
      margin: 50px 0 45px 25px;
    }
    & > .topnews {
      // margin-left: 25px;

      box-sizing: border-box;
      padding-right: 20px;
      flex: 1;
      overflow: hidden;
      padding: 0 20px;
      &.left {
        margin-left: 0;
        padding: 0;
      }
      .title {
        box-shadow: border-box;
        position: relative;
        height: 32px;
        line-height: 32px;
        text-align: right;
        border-bottom: 3px solid #bfbfbf;

        span {
          font-size: 23px;
          font-weight: bold;
          color: #0068b7;
          border-bottom: 3px solid #0068b7;
          background-size: 100% 100%;
          margin-bottom: -3px;
          height: 35px;
          line-height: 28px;
          margin-left: 15px;
          padding-left: 17px;
          text-align: right;
          padding-right: 16px;
          position: absolute;
          bottom: 0;
          left: -13px;
        }
        i {
          font-size: 15px;
          font-family: Microsoft YaHei;
          font-weight: 300;
          color: #959595;
          line-height: 30px;
          font-style: normal;
          cursor: pointer;
          img {
            vertical-align: revert;
          }
        }
      }
      ul {
        background: #fff;
        padding: 10px 0px;
        height: 410px;
        overflow: hidden;
        // border: 1px solid #dedede;
        li {
          // background: url('../assets/images/tips2.png') no-repeat 0 center;
          font-size: 20px;
          color: #333;
          line-height: 29px;
          box-sizing: border-box;
          padding: 23px 0 25px 0px;
          border-bottom: 1px dashed #959595;
          // margin: 16px  0;
          cursor: pointer;
          display: flex;
          // border-bottom: 1px dashed #ddd;
          div {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            flex: 1;
            color: #333;
            font-size: 25px;
          }
          span {
            color: #999;
            font-size: 16px;
          }
        }
      }
    }
    & > .mainnews {
      box-sizing: border-box;
      flex: 1;
      overflow: hidden;
      padding-right: 9px;
      // &.left {
      //   margin-left: 0;
      //   padding: 0;
      // }
      .title {
        box-shadow: border-box;
        position: relative;
        height: 50px;
        line-height: 50px;
        margin-top: 20px;
        // background-color: #c9081b;
        text-align: right;
        .beforetitle {
          position: absolute;
          width: 23px;
          height: 32px;
          top: 6px;
          left: 0px;

          background: url("../assets/images/titleleft-icon.png") no-repeat
            center center;
       
        }
        span {
          font-size: 34px;
          font-weight: bold;
          // font-style: italic;
          // color: #fff;
          color: #c3112c;
          // background: url('../assets/images/title-bg.png') no-repeat center center;
          background-size: 100% 100%;
          height: 70px;
          line-height: 80px;
          text-align: right;
          padding-right: 30px;
          position: absolute;
          bottom: 0;
          left: 35px;
        }
        i {
          color: #c3112c;
          font-size: 36px;
          position: absolute;
          left: 175px;
          bottom: 20px;
          font-weight: 700;
        }
        div {
          font-size: 15px;
          font-family: Microsoft YaHei;
          font-weight: 300;
          color: #959595;
          line-height: 19px;
          font-style: normal;
          cursor: pointer;
          padding-top: 10px;
          img {
            vertical-align: revert;
          }
        }
        .titleline {
          width: 406px;
          height: 11px;
          position: absolute;
          bottom: 16px;
          right: 7px;
          background: url(../assets/images/titleline.png);
        }
      }
      ul {
        height: 270px;
        overflow: hidden;
        li {
          background: url("../assets/images/left-icon.png") no-repeat 0 center;
          font-size: 23px;
          color: #000000;
          line-height: 30px;
          box-sizing: border-box;
          padding: 12px 0 12px 30px;
          // margin: 16px  0;
          cursor: pointer;
          display: flex;
          // border-bottom: 1px dashed #ddd;
          div {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            flex: 1;
          }
          span {
            color: #999;
            font-size: 16px;
          }
        }
      }
    }
    & > .news {
      margin-left: 25px;
      box-sizing: border-box;
      padding-right: 20px;
      flex: 1;
      overflow: hidden;
      padding: 0 20px;
      &.left {
        margin-left: 0;
        padding: 0;
      }
      .title {
        box-shadow: border-box;
        position: relative;
        height: 50px;
        line-height: 50px;
        margin-top: 20px;
        // background-color: #c9081b;
        text-align: right;
        padding-right: 20px;
        span {
          font-size: 28px;
          font-weight: bold;
          // color: #fff;
          color: #0068b7;
          // background: url('../assets/images/title-bg.png') no-repeat center center;
          background-size: 100% 100%;
          height: 70px;
          line-height: 80px;
          width: 180px;
          text-align: right;
          padding-right: 30px;
          position: absolute;
          bottom: 0;
          left: -13px;
        }
        i {
          font-size: 15px;
          font-family: Microsoft YaHei;
          font-weight: 300;
          color: #fff;
          line-height: 30px;
          font-style: normal;
          cursor: pointer;
          img {
            vertical-align: revert;
          }
        }
      }
      ul {
        background: #fff;
        padding: 10px 15px;
        border: 1px solid #dedede;
        li {
          background: url("../assets/images/tips2.png") no-repeat 0 center;
          font-size: 20px;
          color: #333;
          line-height: 25px;
          box-sizing: border-box;
          padding: 15px 0 15px 15px;
          // margin: 16px  0;
          cursor: pointer;
          display: flex;
          // border-bottom: 1px dashed #ddd;
          div {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            flex: 1;
          }
          span {
            color: #999;
            font-size: 16px;
          }
        }
      }
    }
  }
  .picture-video {
    margin: 15px auto 50px;
    display: flex;
    justify-content: space-between;
    .picture {
      width: 600px;
      .no-content {
        height: 235px;
        border: 1px solid #eee;
        box-sizing: border-box;
      }
      ul {
        width: 600px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        li {
          width: 292.5px;
          overflow: hidden;
          position: relative;
          img {
            width: 100%;
            height: 235px;
          }
          p {
            position: absolute;
            left: 0;
            right: 0;
            bottom: 0;
            margin: 0;
            line-height: 37px;
            background: rgba(0, 0, 0, 0.6);
            box-sizing: border-box;
            padding: 0 8px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            font-size: 18px;
            font-family: Verdana;
            color: #fff;
            cursor: pointer;
          }
          &:nth-child(1) {
            margin-right: 15px;
          }
        }
      }
    }
    .video {
      margin-left: 25px;
      box-sizing: border-box;
      padding-right: 20px;
      flex: 1;
      overflow: hidden;
      margin-top: -50px;
      .title {
        background: url("../assets/images/tips.png") no-repeat 0 center;
        display: flex;
        align-items: center;
        justify-content: space-between;
        box-shadow: border-box;
        padding: 0 0 0 20px;
        margin-bottom: 20px;
        span {
          font-size: 28px;
          font-weight: bold;
          color: #ce0801;
          line-height: 16px;
        }
        i {
          font-size: 15px;
          font-family: Microsoft YaHei;
          font-weight: 300;
          color: #333333;
          line-height: 30px;
          font-style: normal;
          cursor: pointer;
        }
      }
      ul {
        height: 235px;
        li {
          position: relative;
          img {
            display: block;
            width: 100%;
            height: 235px;
          }
          p {
            position: absolute;
            left: 0;
            right: 0;
            bottom: 0;
            margin: 0;
            line-height: 37px;
            background: rgba(0, 0, 0, 0.6);
            box-sizing: border-box;
            padding: 0 8px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            font-size: 18px;
            font-family: Verdana;
            color: #fff;
            cursor: pointer;
          }
        }
      }
    }
  }
  .conference {
    .title {
      margin: 0 auto 30px;
      img {
        display: block;
        width: auto;
        max-width: 100%;
        height: auto;
        margin: 0 auto;
      }
    }
    .row {
      display: flex;
      justify-content: space-between;
      .left {
        width: 600px;
        height: 415px;
        .no-content {
          width: 600px;
          height: 415px;
          box-sizing: border-box;
          border: 1px solid #eee;
        }
        & > div {
          position: relative;
        }
        img {
          display: block;
          width: 100%;
          height: 415px;
        }
        p {
          position: absolute;
          left: 0;
          right: 0;
          bottom: 0;
          margin: 0;
          line-height: 37px;
          background: rgba(0, 0, 0, 0.6);
          box-sizing: border-box;
          padding: 0 8px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          font-size: 18px;
          font-family: Verdana;
          color: #fff;
          cursor: pointer;
        }
      }
      .right {
        box-sizing: border-box;
        padding-right: 20px;
        flex: 1;
        overflow: hidden;
        &:nth-child(2) {
          margin-left: 45px;
        }
        .no-content {
          width: 100%;
          height: 415px;
          box-sizing: border-box;
          border: 1px solid #eee;
        }
        ul {
          display: flex;
          align-items: center;
          justify-content: space-between;
          flex-flow: row wrap;
          li {
            &:nth-child(odd) {
              width: 50%;
            }
            &:nth-child(even) {
              width: calc(50% - 35px);
            }
            div {
              background: url("../assets/images/tips2.png") no-repeat 0 center;
              font-size: 20px;
              color: #333;
              line-height: 25px;
              box-sizing: border-box;
              padding: 15px 0 15px 15px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              cursor: pointer;
              border-bottom: 1px dashed #ddd;
            }
          }
        }
      }
    }
  }
  .photo-gallery {
    .threeImg .containt {
      position: relative;
      overflow-y: auto;
      width: 1200px;
      height: 165px;
      overflow: hidden;
      margin: 30px auto 10px;
      ul {
        margin: 0 auto;
        width: 2000px;
        position: absolute;
        left: 0px;
        height: 100%;
        z-index: 10;
        li {
          float: left;
          width: 240px;
          height: 165px;
          margin-right: 50px;
          overflow: hidden;
          cursor: pointer;
          img {
            width: 100%;
            height: 135px;
          }
          p {
            display: block;
            width: 100%;
            text-align: center;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            font-size: 16px;
            color: #3273dc;
            font-size: 16px;
            cursor: pointer;
            line-height: 40px;
          }
        }
      }
    }
  }
  .link {
    height: 12px;
    background-color: #e60012;
    width: 100%;
  }
  .links {
    padding-top: 20px;
    .tit {
      margin: 50px auto 30px;
      img {
        display: block;
        width: auto;
        max-width: 100%;
        height: auto;
        margin: 0 auto;
      }
    }

    ul li {
      width: 187px;
      margin: 0 5px 0;
      flex: 1;
      cursor: pointer;
      img {
        display: block;
        margin: 0 auto;
        width: 100%;
        height: 55px;
        border: 1px solid #eee;
      }
    }
  }
}
</style>
